<div class="language-selector">
  <mat-select [(value)]="currentLanguage" (selectionChange)="onLanguageChange($event.value)" class="flag-select">
    <mat-select-trigger>
      <span class="flag-icon">{{ currentLanguage === 'en' ? '🇬🇧' : '🇱🇦' }}</span>
    </mat-select-trigger>
    <mat-option *ngFor="let lang of supportedLanguages" [value]="lang">
      <span class="flag-icon">{{ lang === 'en' ? '🇬🇧' : '🇱🇦' }}</span>
    </mat-option>
  </mat-select>
</div>
